import styles from './Breadcrumb.module.css';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  onBack?: () => void;
}

export function Breadcrumb({ items, className, onBack }: BreadcrumbProps) {
  if (!items || items.length === 0) {
    return null;
  }

  const classNames = [styles.breadcrumb, className].filter(Boolean).join(' ');

  const arrowContent = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99967 12.6693L3.33301 8.0026L7.99967 3.33594"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6663 8H3.33301"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <nav className={classNames} aria-label="Breadcrumb">
      {onBack ? (
        <button
          type="button"
          className={styles.arrowButton}
          onClick={onBack}
          aria-label="Volver atrás"
        >
          {arrowContent}
        </button>
      ) : (
        <span className={styles.arrow} aria-hidden="true">
          {arrowContent}
        </span>
      )}
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isClickable = !isLast && (item.href || item.onClick);

          const content = (
            <span className={isLast ? styles.labelInactive : styles.labelActive}>
              {item.label}
            </span>
          );

          if (isClickable) {
            return (
              <li key={index} className={styles.item}>
                {item.href ? (
                  <a
                    href={item.href}
                    className={styles.link}
                    onClick={(e) => {
                      if (item.onClick) {
                        e.preventDefault();
                        item.onClick();
                      }
                    }}
                  >
                    {content}
                  </a>
                ) : (
                  <button
                    type="button"
                    className={styles.button}
                    onClick={item.onClick}
                  >
                    {content}
                  </button>
                )}
                {!isLast && <span className={styles.separator} aria-hidden="true">/</span>}
              </li>
            );
          }

          return (
            <li key={index} className={styles.item}>
              <span className={styles.inactive}>
                {content}
              </span>
              {!isLast && <span className={styles.separator} aria-hidden="true">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

Breadcrumb.displayName = 'Breadcrumb';
